(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-showroom-location"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', function(event) {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.matches('[data-showroom-tour]') || !details.open) return;
  const frame = details.querySelector('iframe[data-tour-src]');
  if (frame && !frame.hasAttribute('src')) frame.src = frame.dataset.tourSrc;
}, true);

  } catch(e) { console.error(e); }
})();
})();
